// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1IQzS","paramInput":"JobSimulator_paramInput__1qGz5","input":"JobSimulator_input__fCMsW"};